import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

/**
 * TKP-78 — amaçların kullanıma göre toplu sınıflandırılması. Üç uç: önizleme (yazmaz), uygula, son koşumu geri al.
 * Aynı eylemler iki kütüphanede (yönetici + çalışma alanı) ayrı kapsamlarla çalışır.
 */
const classificationActions = (base) => ({
  async classificationPreview() {
    return rest.post(`${base}/classification/preview`, {});
  },
  async classificationApply() {
    return rest.post(`${base}/classification/apply`, {});
  },
  async classificationUndo() {
    return rest.post(`${base}/classification/undo`, {});
  },
});


export const purpose = createCrudVuexModule({
  namespaced: true,
  path: "/library/purpose",
  moduleName: `purpose`,
  options: { localizedFields: ["name", "description"] },
  actions: {
    async paginate({ getters, rootGetters, commit, dispatch }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        pagination.query.products = { value: rootGetters["product/currentProduct"], isObject: true };
        const response = await rest.post(`/library/purpose/paginate`, { pagination });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async paginateWith({ getters, rootGetters, commit, dispatch }, payload = {}, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        payload.pagination.query.products = { value: rootGetters["product/currentProduct"], isObject: true };

        const response = await rest.post(`/library/purpose/paginate`, { ...payload });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async paginateForSearch({ getters, rootGetters, commit, dispatch }, pagination, clearStateBeforeRest = false) {
      commit("isSearchLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("paginationForSearch", undefined);
        }
        pagination.query.products = { value: rootGetters["product/currentProduct"], isObject: true };
        const response = await rest.post(`/library/purpose/paginate`, { pagination });
        commit("paginationForSearch", response.data);
        return response;
      } finally {
        commit("isSearchLoading", false);
      }
    },
  },
});

export const workspacePurpose = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/purpose",
  options: { localizedFields: ["name", "description"] },
  actions: classificationActions("/workspace/library/purpose"),
});

export const managementPurpose = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/purpose",
  options: { localizedFields: ["name", "description"] },
  actions: classificationActions("/management/library/purpose"),
});

export const legalReason = createCrudVuexModule({
  namespaced: true,
  path: "/library/legal-reason",
  moduleName: `legal-reason`,
  options: { localizedFields: ["name", "description", "kvkkRegulation", "gdprRegulation"] },
  actions: {
    async paginate({ getters, rootGetters, commit, dispatch }, pagination, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        pagination.query.products = { value: rootGetters["product/currentProduct"], isObject: true };
        const response = await rest.post(`/library/legal-reason/paginate`, { pagination });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async paginateWith({ getters, rootGetters, commit, dispatch }, payload = {}, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }
        payload.pagination.query.products = { value: rootGetters["product/currentProduct"], isObject: true };

        const response = await rest.post(`/library/legal-reason/paginate`, { ...payload });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async paginateForSearch({ getters, rootGetters, commit, dispatch }, pagination, clearStateBeforeRest = false) {
      commit("isSearchLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("paginationForSearch", undefined);
        }
        pagination.query.products = { value: rootGetters["product/currentProduct"], isObject: true };

        const response = await rest.post(`/library/legal-reason/paginate`, { pagination });
        commit("paginationForSearch", response.data);
        return response;
      } finally {
        commit("isSearchLoading", false);
      }
    },
  },
});

export const workspaceLegalReason = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/legal-reason",
  options: { localizedFields: ["name", "description", "kvkkRegulation", "gdprRegulation"] },
});

export const managementLegalReason = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/legal-reason",
  options: { localizedFields: ["name", "description", "kvkkRegulation", "gdprRegulation"] },
});

export const legitimateInterest = createCrudVuexModule({
  namespaced: true,
  path: "/library/legitimate-interest",
  moduleName: `legitimate-interest`,
});

export const workspaceLegitimateInterest = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/legitimate-interest",
});

export const managementLegitimateInterest = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/legitimate-interest",
});
